getClassicFacetsType